import type { Concept } from '@rover/rsdk/src/concepts';
import { storeCrossPageAnalyticsEvent } from '@rover/utilities/fireCrossPageEvent';

export type ConsentPurposeFunctional = 'functional';

export type ConsentPurposePerformance = 'performance';

export type ConsentPurposeMarketing = 'marketing';

export type ConsentPurposeStrictlyNecessary = 'strictly-necessary';

export type ConsentPurpose =
  | ConsentPurposeFunctional
  | ConsentPurposePerformance
  | ConsentPurposeMarketing
  | ConsentPurposeStrictlyNecessary;

export abstract class AnalyticsEvent {
  abstract eventName: string;

  abstract consentPurpose: ConsentPurpose;

  abstract concept: Concept;

  eventProperties = {};

  observabilityTags = {};

  constructor(
    eventProperties?: Record<string, unknown>,
    observabilityTags?: Record<string, unknown>
  ) {
    this.eventProperties = eventProperties || {};
    this.observabilityTags = observabilityTags || {};
  }

  /**
   * Use this function call in the case that we are tracking an action that triggers a page load.
   * This will ensure that the event fires off on next page load.
   */
  fireCrossPageEvent(): void {
    storeCrossPageAnalyticsEvent(this);
  }
}
